import { UseFormRegisterReturn } from 'react-hook-form';
import React, { ChangeEventHandler, ComponentProps } from 'react';
import PrimitiveInput from '@/components/form/_primitives/PrimitiveInput.tsx';

type BaseInputProps = {
  register?: UseFormRegisterReturn;
  error?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
} & Omit<ComponentProps<typeof PrimitiveInput>, 'ref'>;

const BaseInput = ({ register, ...props }: BaseInputProps) => {
  return (
    <PrimitiveInput
      {...props}
      {...register}
      onChange={(e) => {
        register?.onChange(e);
        props.onChange?.(e);
      }}
    />
  );
};

export default BaseInput;
